import React, { ChangeEvent } from "react";
import { cn } from "components/ui/cn";

/**
 * Campo de formulario del template. Se alinea con `components/ui/TextField`
 * (mismo alto, radio, borde y estados) para que el login no se vea de otra app.
 */
function InputField(props: {
  id: string;
  label: string;
  extra: string;
  placeholder: string;
  /** Se mantiene por compatibilidad con las llamadas existentes. */
  variant?: string;
  state?: string;
  disabled?: boolean;
  type?: string;

  // Add these two lines:
  value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}) {
  const {
    label,
    id,
    extra,
    type,
    placeholder,
    state,
    disabled,

    // The new props:
    value,
    onChange,
  } = props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className="mb-1.5 block text-[13px] font-medium text-gray-900 dark:text-gray-200"
      >
        {label}
      </label>
      <input
        disabled={disabled}
        type={type}
        id={id}
        // Pass these to the native <input />
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={cn(
          "h-11 w-full rounded-field border bg-white px-3 text-sm text-gray-900",
          "placeholder:text-gray-600 transition-colors duration-150",
          "dark:bg-navy-900 dark:text-white dark:placeholder:text-gray-600",
          disabled === true
            ? "!border-gray-200 !bg-gray-50 dark:!border-white/5 dark:!bg-white/5"
            : state === "error"
            ? "border-red-400 dark:border-red-500/60"
            : state === "success"
            ? "border-green-500 dark:border-green-400"
            : "border-gray-200 hover:border-gray-300 dark:border-white/10 dark:hover:border-white/20"
        )}
      />
    </div>
  );
}

export default InputField;
